<template>
  <tr class="customer-item" v-if="user" style="cursor: pointer">
    <td style="white-space: nowrap">
      <v-btn outline fab small class="extra-small" @click="showEditEmployee = true">
        <v-icon>edit</v-icon>
      </v-btn>

      <v-btn outline fab small class="extra-small" @click="onDeleteEmployee">
        <v-icon>delete</v-icon>
      </v-btn>

      <v-dialog v-model="showEditEmployee" max-width="600" persistent>
        <v-card v-if="showEditEmployee">
          <v-card-text>
            <hafele-customer-manage
              v-model="user"
              type="edit"
              :exceptid="excludedEmpID"
              @close="onClose"
              @onSaveEmpolyee="onSaveEmpolyee"
              :key="user.id"
            ></hafele-customer-manage>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showModal" width="800">
        <v-card>
          <hafele-customer-detail v-model="user" :show="showModal" :key="user.id">
            <div class="text-xs-right">
              <v-btn flat fab small class="extra-small" @click="showModal = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </hafele-customer-detail>

          <v-card-text class="text-xs-center">
            <v-btn outline color="grey" @click="showModal = false">{{ $t('cancel') }}</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- <a href="javascript:void(0)" class="btn btn-primary transparent btn-sm" style="margin-right: 5px; margin-bottom: 5px;"><em class="fab fa-facebook-messenger"/> Chat</a> -->
    </td>
    <td>{{ user.emp_id }}</td>
    <td
      style="min-width: 300px"
      :title="
        (user.emp_first_name ? user.emp_first_name : '') +
        ' ' +
        (user.emp_last_name ? user.emp_last_name : '')
      "
    >
      <div style="display: inline-block; vertical-align: top; margin-top: 5px">
        {{
          ((user.emp_first_name ? user.emp_first_name : '') +
            ' ' +
            (user.emp_last_name ? user.emp_last_name : ''))
            | truncate(35)
        }}
      </div>
    </td>
    <td>{{ user.division }}</td>
    <td>{{ user.department }}</td>
    <td>{{ user.position_name }}</td>
    <td>{{ user.position_level }}</td>
    <td>
      <v-chip small round disabled color="info" class="white--text">{{ user.emp_status }}</v-chip>
    </td>
    <td>{{ user.leave_balance | numberFormat }}</td>
    <td>{{ user.start_point | numberFormat }}</td>
    <td>{{ user.additional_point | numberFormat }}</td>
    <td>{{ user.point_balance | numberFormat }}</td>
    <td>{{ user.redeem_point | numberFormat }}</td>
    <td>
      <v-btn outline fab small class="extra-small" @click="showModal = true">
        <em class="fas fa-align-left" />
      </v-btn>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ModalDialog from '@/components/elements/ModalDialog'
import config from '@/config'
import CustomerItemValue from './CustomerItemValue'
import EditCustomerValue from './EditCustomerValue'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import api from '@/api'
import HafeleCustomerDetail from './HafeleCustomerDetail'
import HafeleCustomerManage from './HafeleCustomerManage'
export default {
  props: ['value', 'excludedEmpID'],
  data: function () {
    return {
      user: undefined,
      showModal: false,
      showAllIntent: false,
      isEditTag: false,
      usertag: '',
      showEditEmployee: false
    }
  },
  components: {
    ModalDialog,
    CustomerItemValue,
    EditCustomerValue,
    specialtext,
    Tags,
    HafeleCustomerDetail,
    HafeleCustomerManage
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterIntent: function () {
      var vm = this
      return vm.user.intentlist.sort(function (a, b) {
        if (parseInt(a[1]) > parseInt(b[1])) {
          return -1
        }

        if (parseInt(a[1]) < parseInt(b[1])) {
          return 1
        }

        return 0
      })
    },
    userLocale: function () {
      var vm = this
      return config.locale.find(function (locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function () {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    }
  },
  mounted: function () {
    this.user = this.value
    this.cached_tag = this.user.tags
  },
  methods: {
    onClose: function () {
      this.showEditEmployee = false
    },
    onSaveEmpolyee: function () {
      this.showEditEmployee = false
    },
    onDeleteEmployee: function () {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete employee?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            this.$emit('deleteEmployee', vm.user.emp_id)
          }
        })
    },
    saveEditTag: function () {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.user.id,
        tags: vm.user.tags
      }
      api.saveUserTags(data, function (error, response) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function () {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    onFailLoad: function () {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 25) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onEditStatus: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value
      }
      api.saveUserStatus(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value
      }
      api.saveUserEmail(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value
      }
      api.saveUserPhoneno(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    }
  },
  watch: {
    value: function () {
      this.user = this.value
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/HafeleCustomerItem.vue